if (!customElements.get('collection-showcase')) {
  customElements.define('collection-showcase', class CollectionShowcase extends HTMLElement {
    connectedCallback() {
      const blocks = [...this.querySelectorAll('[data-showcase-block]')];
      const fs = this.querySelector('[data-showcase-team-select]');
      if (!fs) return;

      // Build sorted team map from all blocks — team_name as value, team_name.toLowerCase() as key
      const teamMap = new Map();
      blocks.forEach(block => {
        (block.dataset.teamNames || '').split(',').map(t => t.trim()).filter(Boolean).forEach(name => {
          const key = name.toLowerCase();
          if (!teamMap.has(key)) teamMap.set(key, name);
        });
      });

      const teams = [...teamMap.entries()].sort(([, a], [, b]) => a.localeCompare(b, undefined, { sensitivity: 'base' }));

      const toDisplayName = key => key.split('-').map(w => w ? w[0].toUpperCase() + w.slice(1) : '').join(' ');

      customElements.whenDefined('fancy-select').then(() => {
        this.#buildSelect(fs, teams, toDisplayName, {});
        this.#fetchLogos(teams.map(([key]) => key)).then(logos => {
          if (Object.keys(logos).length) this.#buildSelect(fs, teams, toDisplayName, logos);
        });
      });

      fs.addEventListener('change', e => {
        const val = e.detail?.value ?? '';
        if (!val) { blocks.forEach(b => { b.style.display = ''; }); return; }
        blocks.forEach(block => this.#updateTiles(block, val));
      });
    }

    async #fetchLogos(teamKeys) {
      const logos = {};
      await Promise.all(teamKeys.map(async key => {
        try {
          const html = await fetch(`/collections/${key}?section_id=team-logo`).then(r => r.text());
          const tmp = document.createElement('div');
          tmp.innerHTML = html;
          const img = tmp.querySelector('#shopify-section-team-logo img');
          if (img?.src) logos[key] = img.src;
        } catch (_) {}
      }));
      return logos;
    }

    #buildSelect(fs, teams, toDisplayName, logos) {
      const placeholderText = fs.getAttribute('label') || 'Select Your Team';
      const currentVal = fs.value;

      fs.querySelectorAll('option').forEach(o => o.remove());
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.setAttribute('selected', '');
      placeholder.textContent = placeholderText;
      fs.appendChild(placeholder);

      teams.forEach(([key, name]) => {
        const opt = document.createElement('option');
        opt.value = key;
        opt.textContent = toDisplayName(key);
        if (logos[key]) opt.dataset.image = logos[key];
        fs.appendChild(opt);
      });

      if (fs.connectedCallback) fs.connectedCallback();
      if (currentVal) fs.value = currentVal;
    }

    #updateTiles(block, teamKey) {
      const container = block.querySelector('[data-showcase-tiles]');
      if (!container) return;

      const allHandles = (block.dataset.productHandles || '').split(',').map(h => h.trim()).filter(Boolean);
      if (!allHandles.length) return;

      const normalizedKey = teamKey.replace(/\s+/g, '-');
      const matched = allHandles.filter(h => h.toLowerCase().includes(normalizedKey));

      // Fallback: fill to 4 with unmatched when fewer than 4 team products
      const selected = [...matched];
      if (selected.length < 4) {
        for (const h of allHandles) {
          if (selected.length >= 4) break;
          if (!selected.includes(h)) selected.push(h);
        }
      }

      block.style.display = '';
      container.style.minHeight = container.offsetHeight + 'px';
      container.innerHTML = selected.slice(0, 4).map(handle => `
        <intersection-loader
          data-url="/products/${handle}"
          data-section-id="product-card"
          data-load-immediately="true"
        ></intersection-loader>
      `).join('');

      const clearMin = () => { container.style.minHeight = ''; };
      container.querySelector('intersection-loader')?.addEventListener('intersection:loaded', clearMin, { once: true });
      setTimeout(clearMin, 2000);
    }
  });
}
